import Backend from 'App/Dataman-Backend';
import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { createImage, uploadImages } from '@/app/api/core/images';
import { CAT_PATENT_RESEARCH } from 'App/utils/Collections';
import { PATENT_RESEARCH_PATHS } from './paths';

export const patentResearchApiAdapter = {
  patentResearch: {
    getList: (params) => apiGet(PATENT_RESEARCH_PATHS.research + PATENT_RESEARCH_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${PATENT_RESEARCH_PATHS.research}/${id}`, { params }),
    createItem: async (data) => {
      const res = await apiPost(PATENT_RESEARCH_PATHS.research, { data });
      await uploadImages(CAT_PATENT_RESEARCH, data.images, {
        patent_research_id: res.data.id,
      }).catch();
      return res;
    },
    updateItem: async (id, data) => {
      const res = await apiPatch(`${PATENT_RESEARCH_PATHS.research}/${id}`, { data });
      if (data.images) {
        const images = data.images.filter((img) => img.isNew || img.isDirty);
        await uploadImages(CAT_PATENT_RESEARCH, images, { 'research.id': id }).catch();
      }
      return res;
    },
    downloadFile: async (id) => {
      const res = await Backend.loadBlobData({
        url: `${PATENT_RESEARCH_PATHS.research}/${id}/file`,
        method: 'get',
        responseType: 'blob',
        headers: { accept: 'application/octet-stream' },
      });
      return res;
    },
  },
  patentResearchImages: {
    getList: (patent_research_id, params = {}) =>
      apiGet(PATENT_RESEARCH_PATHS.images, {
        params: {
          ...params,
          'research.id': patent_research_id,
        },
      }),
    getItem: (id, params) => apiGet(`${PATENT_RESEARCH_PATHS.images}/${id}`, { params }),
    createItem: (img, patent_research_id, is_default = false, session_interval = 0) =>
      createImage(CAT_PATENT_RESEARCH, img, { patent_research_id, is_default, session_interval }),
    updateItem: (id, data) => apiPatch(`${PATENT_RESEARCH_PATHS.images}/${id}`, { data }),
    remove: (id) => apiDelete(`${PATENT_RESEARCH_PATHS.images}/${id}`),
  },
  patentResearchDocument: {
    getList: (params) => apiGet(PATENT_RESEARCH_PATHS.documents + PATENT_RESEARCH_PATHS.suffix, { params }),
    createItem: (data) => apiPost(PATENT_RESEARCH_PATHS.documents, { data }),
    updateItem: (id, data) => apiPatch(`${PATENT_RESEARCH_PATHS.documents}/${id}`, { data }),
    deleteItem: (id) => apiDelete(`${PATENT_RESEARCH_PATHS.documents}/${id}`),
  },
  patentResearchDocumentComment: {
    createItem: (data) => apiPost(PATENT_RESEARCH_PATHS.documentComments, { data }),
    updateItem: (id, data) => apiPatch(`${PATENT_RESEARCH_PATHS.documentComments}/${id}`, { data }),
    deleteItem: (id) => apiDelete(`${PATENT_RESEARCH_PATHS.documentComments}/${id}`),
  },
};
